const STORAGE_PREFIX = "abp_game_";

export const getResponseIdFromSearch = (search = window.location.search) => {
    const params = new URLSearchParams(search);
    return params.get("responseId") || params.get("responseid") || null;
};

export const getStorageKey = (responseId) => `${STORAGE_PREFIX}${responseId || "default"}`;

export const loadProgress = (responseId) => {
    try {
        const raw = localStorage.getItem(getStorageKey(responseId));

        if (!raw) {
            return null;
        }

        return JSON.parse(raw);
    } catch {
        return null;
    }
};

export const saveProgress = (responseId, pageReducer, agreementPassed = true) => {
    try {
        localStorage.setItem(getStorageKey(responseId), JSON.stringify({
            pageReducer,
            agreementPassed,
            savedAt: Date.now(),
        }));
    } catch {
        // ignore quota / private mode errors
    }
};

export const clearProgress = (responseId) => {
    try {
        localStorage.removeItem(getStorageKey(responseId));
    } catch {
        // ignore
    }
};
